import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import Box from '@mui/material/Box';
import { lazyLoad } from 'utils/loadable';
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { GlobalReducer } from 'types/globalReducer';
import { useEffect, useState } from 'react';
import ContentAPI from 'api/contentAPI';
import { Post } from 'types/post';
import useWindowDimensions from 'app/components/useWindowDimensions';
import { specialPages, TlinkNames } from 'types/links';
import { GlobalColumn } from 'app/components/globalPostCell';
import { Link as RouterLink } from 'react-router-dom';
import {
  List,
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
} from 'react-virtualized';
import Misc from '../../../functions/misc';

interface ISpecialPages {
  n: string;
  l: string;
}

export const LegislativeOrdinance = lazyLoad(
  () => import('./LegislativeOrdinance'),
  module => module.LegislativeOrdinanceContent,
);

export function LegislativeOrdinanceContent(props: any) {
  const [selectedLink, setSelectedLink] = useState<ISpecialPages>();
  const [posts, setPosts] = useState<Post[]>([]);
  const [triggerOnce, setTriggerOnce] = useState<boolean>(false);
  const globalColumn = React.useMemo(() => [GlobalColumn], []);
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  // Pagination state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const selectedNav: TlinkNames | string = useSelector(
    (state: GlobalReducer) => state.navData.selectedNav,
  );
  const { height, width } = useWindowDimensions();

  useEffect(() => {
    setSelectedLink(specialPages.find(x => x.l === selectedNav));
    //console.log(selectedNav);
  }, [selectedNav]);

  useEffect(() => {
    setTriggerOnce(triggerOnce ? true : false);
    async function getPostByUniqueLink() {
      // switch (selectedLink?.c) {
      //   case 'basic':
      //     setColumnType(basicColumn);
      //     break;
      //   case 'post':
      //     setColumnType(postColumn);
      //     break;
      //   default:
      //     setColumnType(postColumn);
      //     break;
      // }

      const _filter = {
        ...(selectedNav === 'announcements' || selectedNav === 'posts'
          ? { uniqueLink: selectedNav ? selectedNav : undefined }
          : { postType: selectedNav ? selectedNav : undefined }),
      };
      //console.log(_filter);
      //@ts-ignore
      const data: Post[] = await ContentAPI.getPosts(dispatch, { ..._filter });
      //console.log(selectedNav, data);
      setPosts(data);
      //console.log('UNIQUELINK DATA ===> ', data);
      //console.log(data);
    }
    getPostByUniqueLink();
    //@ts-ignore

    //setAnnouncement(findAnnouncementByID(Number(params.announcementId)));
    //console.log(findAnnouncementByID(Number(params.announcementId)));
  }, [selectedNav, triggerOnce]);

  //console.log(pathname.includes('testing'));
  //console.log(specialPages.find(x => x.l === selectedNav));

  const cache = new CellMeasurerCache({
    fixedWidth: true,
    defaultHeight: 180,
  });
  // Handle page change
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <>
      <Helmet>
        <title>Legislative Ordinance</title>
        <meta name="description" content="Legislative Ordinance" />
      </Helmet>
      <Box sx={{ p: '15px' }}>
        <Paper
          variant="outlined"
          sx={{
            // mt: '7.5px',
            p: '12px',
            '& a': {
              textDecoration: 'none',
            },
            '& .announcementHeader': {
              color: 'text.primary',
            },
            '& .announcementHeader:hover': {
              color: 'text.secondary',
            },
            backgroundColor: 'primary.main',
            '@media (max-width: 900px)': {
              textAlign: 'center',
            },
            '@media (min-width: 900px)': {},
            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
          }}
        >
          <Typography variant="h4" sx={{ color: 'background.paper' }}>
            Legislative Ordinance
          </Typography>
        </Paper>
        <Box sx={{ flex: 1, mt: 2 }}>
          <Paper>
            <Box
              sx={{
                width: '100%',
                overflow: posts.length > 20 ? 'auto' : 'unset',
                maxHeight: posts.length > 20 ? 900 : 'unset', // adjust as needed
              }}
            >
              <Table
                stickyHeader
                sx={{
                  '& th': {
                    backgroundColor: 'primary.main',
                    color: 'background.paper',
                  },
                }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell>Title</TableCell>
                    <TableCell sx={{ minWidth: 180, width: 150 }}>
                      Date Posted
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {posts
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((post, idx) => (
                      <TableRow key={post.id}>
                        <TableCell>
                          <RouterLink
                            to={`../${post.uniqueLink}/${post.id}`}
                            style={{
                              textDecoration: 'none',
                              color: '#1976d2',
                              fontWeight: 600,
                            }}
                          >
                            {post.title}
                          </RouterLink>
                        </TableCell>
                        <TableCell sx={{ minWidth: 180, width: 150 }}>
                          {Misc.parseAPIDateTime(post.datePosted)}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </Box>
            <TablePagination
              sx={{
                backgroundColor: 'primary.main',

                '& p': {
                  backgroundColor: 'primary.main',
                  color: 'background.paper',
                },
                '& .MuiSelect-select': {
                  backgroundColor: 'primary.main',
                  color: 'background.paper',
                },
                '& .MuiTablePagination-actions': {
                  color: 'background.paper',
                },
              }}
              component="div"
              count={posts.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 25, 50]}
            />
          </Paper>
        </Box>
      </Box>
    </>
  );
}
